import React from 'react';

import style from './style.module.css';

const SectionBorder = ({ children, showBorder = true }) => {
    return (
        <div className={showBorder === true ? style.sectionBorder : undefined}>{children}</div>
    )
}

export default SectionBorder;